import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from '../../core/services/api/api.service';
import { IEventSignInSubmitData } from './login-form/IEventSignInSubmitData';
import { ProgressBarService } from '../../shared/progress-bar/progress-bar.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AuthRedirectService } from '../../core/services/auth-redirect.service';

@Component({
  selector: 'app-sign-in-page',
  templateUrl: './sign-in-page.component.html',
  styleUrls: ['./sign-in-page.component.scss'],
})
@UntilDestroy()
export class SignInPageComponent implements OnInit, OnDestroy {
  private callbackUrl: string | undefined;

  constructor(
    private readonly router: Router,
    private readonly activatedRoute: ActivatedRoute,
    private readonly apiService: ApiService,
    readonly progressBarService: ProgressBarService,
    private readonly matSnackBar: MatSnackBar,
    private readonly authRedirectService: AuthRedirectService,
  ) {}

  ngOnInit() {
    this.activatedRoute.queryParamMap
      .pipe(untilDestroyed(this))
      .subscribe((q) => (this.callbackUrl = q.get('callback')));
  }

  ngOnDestroy() {
    this.matSnackBar.dismiss();
  }

  onClickForgot() {
    this.router.navigate(['/forgot']);
  }

  onClickSubmit(event: IEventSignInSubmitData) {
    this.matSnackBar.dismiss();
    this.apiService
      .postAuthSignIn(event)
      .pipe(untilDestroyed(this))
      .subscribe(
        (s) => {
          this.authRedirectService.redirect(s.scope, this.callbackUrl);
        },
        (err) => {
          console.error(err);
          this.matSnackBar.open(
            'Password does not match username; please confirm the password. ' +
              'If the problem persists, follow the "Forgot password" process or contact support@quantapower.com',
            'Close',
          );
        },
      );
  }
}
